import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
// import Button from 'common/components/elements/buttons/primary';

const ConversationNotActive = ({
   // onClick,
   text,
}) => {
   return (
      <div className='flex flex-col items-center my-auto w-full h-full z-50 justify-center bg-panel dark:bg-panel-dark '>
         <div className='flex items-center justify-center h-6 w-6 mb-5'>
            <Icon
               name='chat-mute'
               color='placeholder'
               darkColor='placeholder-dark'
               size='lg'
            />
         </div>
         <span className='text-secondary dark:text-secondary-dark leading-tight'>{text}</span>
         {/*
         <div className='h-9 flex w-24 mt-11'>
            <Button
               text='Ok'
               primaryColor
               onClick={ onClick }
               backgroundColor='transparent'
            />
         </div> */}
      </div>
   )
};
ConversationNotActive.defaultProps = {
   // onClick: () => {},
};
ConversationNotActive.propTypes = {
   // onClick: PropTypes.func,
   text: PropTypes.string,
};

export default ConversationNotActive;
